import { render, staticRenderFns } from "./SettingsTitle.vue?vue&type=template&id=b08b905e&scoped=true&"
import script from "./SettingsTitle.vue?vue&type=script&lang=js&"
export * from "./SettingsTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08b905e",
  null
  
)

export default component.exports